import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { API_VPP, URL_SUPPORT, API_ADMIN_GERENCIA, ROW_COUNT, API_ADMIN_PAGINACION } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import IVicePresidencia from "../../../entities/IVicePresidencia";
import AdminLista from "../AdminLista";
import IGerencia from "../../../entities/IGerencia";
import { cParamsActiveOrderTitle } from "../../../helpers/paramsHelper";
interface IGerenciaProps {
  cbVicePresidencia?: Array<IVicePresidencia>;
  items?: Array<any>;
  is_test?: boolean;
}
const Gerencia = ({ cbVicePresidencia, items, is_test }: IGerenciaProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [comboVcc, setComboVcc] = useState<Array<IVicePresidencia>>(cbVicePresidencia || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let params = { PAGINA: 1, PAGINADO: ROW_COUNT, ORDENADOPOR: "ID", ORIENTACION: "DESC" };

    let result = is_test
      ? { data: items, pages: 10 }
      : (await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, params)).result;

    let list = result.data;
    setListItems(list);
    params.PAGINADO = ROW_COUNT;
    let pages = result.pages;
    setPages(pages);

    const combo = is_test
      ? []
      : (await getAPI(`${URL_SUPPORT}${API_VPP}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle)).result.data;
    setComboVcc(combo);
    setIsLoading(false);
  }, [token]);

  const paging = (page: any) => {
    setPage(page);
    let params = { PAGINA: page };
    filter(params, true);
  };
  const filter = (filter: Partial<IGerencia>, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.VICEPRESIDENCIA = filter.ID_VICEPRESIDENCIA?.toString() || "";
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }

    setPage(filter.PAGINA);

    getAPI(`${URL_SUPPORT}${API_ADMIN_PAGINACION}?ROWCOUNT=${size}&SCHEMA=public&TABLENAME=GERENCIA_SUBGERENCIA`, {
      Authorization: `Bearer ${token}`,
    })
      .then((result) => {
        setIsLoading(false);
        setPages(result.result.data.PAGINAS);
      })
      .catch((error) => {
        console.log(error);
      });

    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const edit = (value: IGerencia, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    if (value.ID == "") {
      delete value.ID;
    }
    postAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}`, value, { Authorization: `Bearer ${token}` })
      .then((result) => {
        filter(filters, value?.ID != undefined);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ENCARGADO_ZONAL: "",
              ENCARGADO_ZONAL_DISPLAY: "",
              ES_GERENTE_BACKUP: true,
              ES_USUARIO_BACKUP: true,
              GERENTE_BACKUP: "",
              GERENTE_BACKUP_DISPLAY: "",
              GERENTE_RESPONSABLE: "",
              GERENTE_RESPONSABLE_DISPLAY: "",
              ID_MAESTRO_GERENCIA_SUBGERENCIA: "1",
              ID_VICEPRESIDENCIA: 1,
              NOMBRE_VICEPRESIDENCIA: "",
              USUARIO_BACKUP: "",
              USUARIO_BACKUP_DISPLAY: "",
              USUARIO_RESPONSABLE: "",
              USUARIO_RESPONSABLE_DISPLAY: "",
              VICEPRESIDENCIA: "",
              ACTIVO: true,
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
              TITULO: "",
            },
            {}
          );
          paging(1);
        }}></button>
      <AdminLista
        reload={filter}
        items={[
          {
            type: "ID_VICEPRESIDENCIA",
            value: comboVcc.map((vcc) => {
              return { text: vcc.TITULO, value: vcc.ID };
            }),
          },
        ]}
        callback={edit}
        data={listItems}
        tipo={"Gerencia"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Gerencia"
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default Gerencia;
